<template>
  <v-container fluid>
    <v-app-bar dark app color="primary">
      <v-btn icon>
        <v-icon>mdi-airplane</v-icon>
      </v-btn>
      <v-toolbar-title>onBoarding</v-toolbar-title>
      <v-spacer />
      <v-text-field
        class="mr-2"
        v-model="search"
        append-icon="mdi-magnify"
        label="Klasse oder Teil-Klasse"
        clearable
        single-line
        hide-details
        id="search"
      ></v-text-field>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tabs-slider color="error"></v-tabs-slider>
          <v-tab :to="{ name: 'OnBoardingSchoolClasses' }">
            Schulklassen
          </v-tab>
          <v-tab :to="{ name: 'OnBoardingCheckinGYM0' }">Check-in GYM0</v-tab>
          <v-tab :to="{ name: 'OnBoardingCheckinGYM1' }">Check-in GYM1-4</v-tab>
          <v-tab :to="{ name: 'OnBoardingPersonal' }"> Personalien </v-tab>
          <v-tab :to="{ name: 'OnBoardingSettings' }"> Einstellungen </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <router-view :search="search" />
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "OnBoarding",

  data() {
    return {
      search: "",
    };
  },
});
</script>
